import TextButton from '@components/button/text-button/TextButton';
import styled from '@emotion/styled';
import {Grid} from '@mui/material';
import {APP} from 'src/styles/variables';

export const DataGridComponentGrid = styled(Grid)`
  .MuiDataGrid-main {
    border: 1px solid #0000001a;
    border-radius: 5px;
    margin: 1.8rem 0 0 1rem;
    box-shadow:
      (0 0 0 / 20%) 0px 2px 1px -1px,
      rgb(0 0 0 / 14%) 0px 1px 1px 0px,
      rgb(0 0 0 / 12%) 0px 1px 3px;
  }
  .data-grid-wrapper {
    margin: 0 !important;
  }
`;

export const RetentionInputLabelStyle = styled('div')`
  margin: 0;
  font-family: Roboto-Regular;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
`;

export const FormControlGrid = styled(Grid)`
  width: 100%;
`;

export const NoDataGridComponentDiv = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5rem;
`;

export const ComponentLoaderGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 5rem;
`;

export const ContainerGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  width: 100%;
  // margin: 1rem;
`;

export const BottomSectionGrid = styled(Grid)`
  display: flex;
  width: 100%;
  flex-direction: row;
  // justify-content: space-between;
`;

export const DocumentsGrid = styled(Grid)`
  margin-left: 15px;
`;

export const FooterGrid = styled(Grid)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin: 1rem 0 1rem 1rem;
`;

export const RetentionInputGrid = styled(Grid)`
  height: inherit;
  display: flex;
  flex-direction: row;
`;

export const RetentionInput = styled('input')`
  border: 2px solid rgba(0, 0, 0, 0.23);
  width: 2.8rem;
  height: inherit;
  font-size: 1.2rem;
  margin: 0.4rem;
  border-radius: 10%;
`;

export const DocumentsLabel = styled('h4')`
  margin: 0 0 0 0.4rem;
  font-weight: bold;
`;

export const RetentionLabel = styled('h3')`
  margin: 0.2rem 0.4rem 0 0;
  font-weight: normal;
`;

export const SelectDropdownGrid = styled(Grid)`
  margin: 1rem 0 0 1rem;
`;

export const SelectDropdownLabel = styled('h4')`
  font-weight: normal;
  margin-bottom: 0.5rem;
`;

export const GenerateReportButton = styled(TextButton)`
  font-size: 14px;
  font-weight: normal;
  background-color: ${APP.PALETTE.MODULE_LAYOUT_COLOR.BUTTON};

  &:hover {
    background-color: ${APP.PALETTE.MODULE_LAYOUT_COLOR.HOVER_BUTTON};
  }
`;

export const ClinicalDocumentContainerGrid = styled(Grid)`
  height: 90vh;
  border: 1px solid;
  border-color: ${APP.PALETTE.CLINICAL_DOC.BORDER_COLOR};
  border-radius: 8px;
  padding: 0.5rem;
  margin: 0.5rem;
`;

export const ClinicalDocumentWrapperGrid = styled(Grid)`
  height: 100%;
  background-color: ${APP.PALETTE.CLINICAL_DOC.BACKGROUND_COLOR};
  padding: 0.5rem;
  border-radius: 8px;
  overflow-y: auto;
`;
